// src/pages/Media/Media.jsx
import React, { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import CustomAudioPlayer from '../../components/CustomAudioPlayer/CustomAudioPlayer';
import VideoEmbed from '../../components/LocalVideo/LocalVideo';

// omat MP3-tiedostosi
import trackLuvulla from '../../assets/audio/Bilebandi_Joyride_-_2080-luvulla.mp3';

// paikallinen video ja sen poster
import myVideo from '../../assets/tiktokpromo.mp4';

export default function Media() {
  useEffect(() => {
    AOS.init({});
  }, []);

  return (
    <>
      <section
        id="media"
        aria-labelledby="media-heading"
        className="w-full bg-joyrideLight dark:bg-joyrideNavy transition-colors py-12"
      >
        <div className="max-w-6xl mx-auto px-4 md:px-8 lg:px-16 space-y-12">
          {/* Otsikko ja johdanto */}
          <div
            data-aos="fade-down"
            className="prose max-w-none prose-lg dark:prose-invert text-joyrideNavy dark:text-joyrideLight"
          >
            <h2
              id="media-heading"
              className="text-4xl font-lobster font-bold text-joyridePurple dark:text-joyrideCyan mb-4 dark:text-shadow-lg"
              title="Media"
            >
              Media
            </h2>
            <p className="mb-6 font-light">
              Tutustu Bilebändi Joyriden monipuoliseen livemusiikkiin ja cover-kappaleisiin, jotka tuovat bileiden tunnelman suoraan kotisohvallesi. 
              Tarjolla on äänitteitä ja SoundCloud-upotuksia, jotka esittelevät bändin energisen ja monipuolisen ohjelmiston. 
              Videoita on parhaillaan työn alla ja ne julkaistaan pian, joten pysy kuulolla ja pääset kokemaan keikkatunnelman entistäkin vahvemmin!
            </p>

            {/* Paikallinen MP4-video */}
            <div data-aos="fade-up">
              <VideoEmbed
                src={myVideo}
                title="Joyride promo video"
                width={1920}
                height={1080}
              />
            </div>
          </div>

          {/* Oma MP3-soitin */}
          <div data-aos="fade-up" className="space-y-8">
            <CustomAudioPlayer
              src={trackLuvulla}
              title="Bilebändi Joyride – 2080-luvulla"
            />
          </div>

          {/* SoundCloud-upotukset – tärkeä SEO ja saavutettavuus */}
          {[
            {
              title: 'Rebel Yell',
              embedSrc: 'https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/1418246374&color=%23ff5500',
              link: 'https://soundcloud.com/spiderlegs-productions/bilebandi-joyride-rebel-yell',
            },
            {
              title: 'Teuvo, maanteiden kuningas',
              embedSrc: 'https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/1397193199&color=%23ff5500',
              link: 'https://soundcloud.com/spiderlegs-productions/teuvo-maanteiden-kuningas',
            },
            {
              title: 'Paratiisi',
              embedSrc: 'https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/1105936846&color=%23ff5500',
              link: 'https://soundcloud.com/spiderlegs-productions/paratiisi',
            }
          ].map((item, i) => (
            <div
              key={i}
              data-aos="fade-up"
              data-aos-delay={200 + i * 200}
              className="mb-8"
            >
              <iframe
                title={`Kuuntele Joyride – ${item.title}`}
                aria-label={`Kuuntele Joyride – ${item.title}`}
                width="100%"
                height="166"
                scrolling="no"
                frameBorder="no"
                src={item.embedSrc}
                loading="lazy"
              />
              <p className="mt-2 text-sm text-joyrideNavy dark:text-joyrideLight font-light">
                <a
                  href="https://soundcloud.com/spiderlegs-productions"
                  className="hover:underline hover:font-bold transition"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Spiderlegs Productions
                </a>{' '}
                –{' '}
                <a
                  href={item.link}
                  className="underline hover:font-bold transition"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Kuuntele Joyride – {item.title}
                </a>
              </p>
            </div>
          ))}
        </div>
      </section>
    </>
  );
}
